// extracted by mini-css-extract-plugin
export default {"warning":"styles_warning__YmOQ1","icon":"styles_icon__TWoss","title":"styles_title__wrzDq","header":"styles_header__fTtqL"};